export const colors = {
  appColor: '#343C6A',
  sColor: '#49B8CC',
  activityTimeColor: '#0E0E6F',
};

export const drawerWidth = 240;
